import React from 'react';
import { useAuth } from '../Auth/AuthProvider';
import { AnalyticsEvent, useAnalytics } from '../Context/AnalyticsProvider';
import { useNavigate } from '../ProtectedRoute';
import Button from './Button';

const SignUpPrompt: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();
  if (user !== null) return null;

  return (
    <div
      className="fixed bottom-8 z-50 w-[600px] bg-blue-100 p-4 shadow-xl rounded-xl left-1/2 transform -translate-x-1/2
        max-lg:bottom-0
        max-lg:w-full
    "
    >
      <div
        className="flex flex-row items-center justify-center h-full gap-4
        max-lg:flex-col
      "
      >
        <div className="flex flex-col items-start justify-center text-left">
          <h4 className="text-lg font-bold text-blue-600">
            Create a Free account to get full access
          </h4>
          <p className="text-sm text-gray-500">
            If you're a kid, ask a parent to help you create an account. Parents
            can sign up for their kids.
          </p>
        </div>
        <Button
          variant="primary"
          mode="button"
          onClick={() => {
            navigate('/signup');
            trackEvent(AnalyticsEvent.SIGNUP_PROMPT_CTA_CLICKED);
          }}
          className="max-lg:w-full"
        >
          Create a Free Account
        </Button>
      </div>
    </div>
  );
};

export default SignUpPrompt;
